/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from "../apiContext";
import ViewForm from "./ViewForm";
import { FaEye, FaFilePdf, FaCheck  } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
import PdfModal from "./PdfModal";
import notify from "../../helper/Notify";
import { Badge } from 'reactstrap';
import axios from "axios";
import { getToken } from "../../auth/AuthService";
import ConfirmationBox from "../../helper/ConfirmBox";
import {isWithinInterval } from 'date-fns';
import { useLoader } from "../../helper/Loader";

export function LeadsApi({ page = 1, pageSize, searchQuery, selectedCategory, selectStatus, emailType, dateRange, setTotalData, setExportData }) {
  const { data,setData, error } = useContext(ApiContext);
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [confirmBox, setConfirmBox] = useState(false);
  const [markData, setMarkData] = useState(null);
    const{setIsLoader} = useLoader();

  const token = getToken() ;

  const closeModal = () => setShowModal(false);
  const modalClose = () => setPdfModal(false);
  const excludedEmails = ["aman.yadav@c-zentrix.com", "aravind.jayakumar@c-zentrix.com", "monish@c-zentrix.com"];
  const collectLeadData = `${window.API_CONFIG.All_Api.leads}/update`

  const leadAPI  = window.API_CONFIG.All_Api.leads


  useEffect(() => {
    try {
      if (!data.leads || data.leads.length === 0) {
        throw new Error("No data available");
      }

      let filteredData = data.leads;

      filteredData = filteredData.filter(lead => !excludedEmails.includes(lead.Email));

      filteredData = filteredData.sort((a, b) => {
        return new Date(b.dateTime) - new Date(a.dateTime);
      });

      if (selectedCategory === "Ham Emails") {
        filteredData = filteredData.filter(lead => lead.classification === "ham");
      } else if (selectedCategory === "Spam Emails") {
        filteredData = filteredData.filter(lead => lead.classification === "spam");
      }
      if (selectStatus === "Pending") {
        filteredData = filteredData.filter(lead => lead.mail_send_flag === "0");
      } else if (selectStatus === "Send") {
        filteredData = filteredData.filter(lead => lead.mail_send_flag !== "0");
      }
      if (emailType === "Subscribe") {
        filteredData = filteredData.filter(lead => lead.mailType === "subscribe");
      } else if (emailType === "Callback") {
        filteredData = filteredData.filter(lead => lead.mailType === "callback");
      } else if (emailType === "Free Trail Demo") {
        filteredData = filteredData.filter(lead => lead.mailType === "freeTrailDemo");
      } else if (emailType === "Demo") {
        filteredData = filteredData.filter(lead => lead.mailType === "demo");
      } else if (emailType === "Ebook") {
        filteredData = filteredData.filter(lead => lead.mailType === "ebookemail");
      } else if (emailType === "Casestudy") {
        filteredData = filteredData.filter(lead => lead.mailType === "casestudy");
      } else if (emailType === "Career") {
        filteredData = filteredData.filter(lead => lead.mailType === "career");
      }
      else if (emailType === "webinar") {
        filteredData = filteredData.filter(lead => lead.mailType === "registerwebinar");
      }
      else if (emailType === "blog") {
        filteredData = filteredData.filter(lead => lead.mailType === "blog");
      }

    if (dateRange?.startDate && dateRange?.endDate) {
  const startDate = new Date(dateRange.startDate);
  startDate.setHours(0, 0, 0, 0); // Start of the day

  const endDate = new Date(dateRange.endDate);
  endDate.setHours(23, 59, 59, 999); // End of the day

  filteredData = filteredData.filter(lead => {
    const leadDate = new Date(lead.dateTime);
    return isWithinInterval(leadDate, {
      start: startDate,
      end: endDate,
    });
  });
}
      if (searchQuery) {
        const searchLower = searchQuery.toLowerCase();
        filteredData = filteredData.filter(lead =>
          (lead.fullname && lead.fullname.toLowerCase().includes(searchLower)) ||
          (lead.Email && lead.Email.toLowerCase().includes(searchLower)) ||
          (lead.PhoneNumber && lead.PhoneNumber.toLowerCase().includes(searchLower)) ||
          (lead.dateTime && lead.dateTime.toLowerCase().includes(searchLower))
        );
      }

    setFilteredLeads(filteredData);
    setTotalData(filteredData.length);
    setExportData(filteredData);
    } catch (error) {
      setFilteredLeads([]);
    setTotalData(0);
    setExportData([]);
      console.error("Error fetching or processing data:", error);
    }
  }, [data.leads, searchQuery, page, pageSize, selectedCategory,selectStatus,emailType, dateRange,setTotalData,setExportData]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedLeads = filteredLeads.slice(startIndex, endIndex);

    const pdfOpen = (lead) => {
      // Check if the fileName ends with '.doc'
      if (lead.fileName.endsWith('.pdf')) {
        setPdfModal(true);
        setModalData(lead);
         
      } else {
        notify.error("We are currently unable to display this file extension. We're working on supporting it, and it will be available soon.");
      }
  };

  const fetchLeads = async () => {
  try {
    const response = await axios.get(`${window.API_CONFIG.All_Api.leads}`, {
      headers: {
        "x-access-token": token,
      },
    });
    setData(prev => ({
      ...prev,
      leads: response.data?.data || [],
    }));
  } catch (error) {
    console.error("Error fetching leads:", error);
  }
};

  const handleMark = (dataToRemove) => {
    setConfirmBox(true);
    setMarkData(dataToRemove);
  };
const handleMarkAsHam = async () => {
   setConfirmBox(false)
   setIsLoader(true)
  try {
    const updatedLeadData = {
      ...markData,
      classification: markData.classification === "ham" ? "spam" : "ham" 
    };

    //Lead API call for update data in mongoDB
    const leadResponse = await axios.post(
      leadAPI,
      updatedLeadData, 
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": token,
        },
      }
    );

    console.log("Lead API response:", leadResponse.data);
  
    const actionData = {
      Email: updatedLeadData.Email,
      classification: updatedLeadData.classification,
      createdDate: new Date().toISOString().slice(0, 10),
    };
     const existingDataResponse = await axios.get(collectLeadData, {
      headers: {
        "x-access-token": token,
      },
    });

     const existingViewModels = existingDataResponse.data?.data?.ViewModels || [];
    existingViewModels.push(actionData);

    // Step 6: POST updated data back
    const collectDataResponse = await axios.post(
      collectLeadData,
      { ViewModels: existingViewModels },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": token,
        },
      }
    );

   if (collectDataResponse.data?.success === true) {
        console.log("Successfully updated lead and collected data.");
        await fetchLeads(); // 🔄 Refresh the UI
       
      }


    console.log("Collect Data API response:", collectDataResponse.data);

  } catch (error) {
    console.error("Error in handleMarkAsHam:", error);
  }
  finally{
        setIsLoader(false);
      }
};


const closeDelModal = () => setConfirmBox(false);

    return (
      <>
        <tbody>
          {filteredLeads.length === 0 ? (
            <tr>
              <td className="noFound" colSpan="12">No data found</td>
            </tr>
          ) : (
            paginatedLeads.map((lead, index) => {
              const id = `item-${index}`;

              return (
                <tr key={id}>
                  <td
                    title="View"
                    className="view"
                    onClick={() => {
                      setShowModal(true);
                      setModalData(lead);
                    }}
                  >
                    <FaEye />
                  </td>

                  {lead.fileName === null || lead.fileName === '' ? (
                    <td>
                      <FaCircleXmark />
                    </td>
                  ) : lead.mailType === "career" ? (
                    <td
                      title="Pdf"
                      className="pdf"
                      onClick={() => pdfOpen(lead)}
                    >
                      <FaFilePdf />
                    </td>
                  ) : (
                    <td>
                      <FaCircleXmark />
                    </td>
                  )}
                  {/* <td
                  className="rotate-icon"
                  title="Rotate"
                  onClick={() => handleOpen(lead)}
                  style={{ cursor: 'pointer' }}
                >
                  {toggledRows[lead.Email] && lead.classification !== "ham" ? (
                    <FaToggleOn color="green" />
                  ) : (
                    <FaToggleOff />
                  )}
                </td> */}
                  <td title={lead.fullname}>{lead.fullname}</td>
             <td title={lead.classification}>
               {lead.classification === "spam" ? (
                <Badge color="danger"
                 style={{ color: "#fff", fontSize: "0.75rem" }}
                 className="d-inline-flex align-items-center px-2 py-1 rounded-pill"
                  >
                  <FaCircleXmark className="me-1" style={{ color: "white", fontSize: "0.65rem" }} />
                 SPAM
                </Badge>
                   ) : (
                 <Badge color="success"
                  style={{  color: "#fff", fontSize: "0.75rem" }}
                   className="d-inline-flex align-items-center px-2 py-1 rounded-pill"
                  >
                   <FaCheck className="me-1" style={{ color: "white", fontSize: "0.65rem" }} />
                     HAM
                  </Badge>
                     )}
              </td>
                  <td title={lead.Email}>{lead.Email}</td>
                  <td title={lead.PhoneNumber}>{lead.PhoneNumber}</td>
                  {/* <td title={lead.subject}>
                    {lead.subject && lead.subject.length > 30
                      ? `${lead.subject.substring(0, 30)}...`
                      : lead.subject}
                  </td> */}

                  <td title={lead.dateTime}>
                    {lead && lead.dateTime ? lead.dateTime : "Not available"}
                  </td>
                  <td>
                    <span className={`status ${lead.mail_send_flag !== "0" ? "active" : "inactive"}`}>
                      {lead.mail_send_flag !== "0" ? "Send" : "Pending"}
                    </span>
                  </td>
                 <td title={lead.classification}>
  {lead.classification === "ham" ? (
   <button
      color="danger"
      size="sm"
      className="markButton spam"
      onClick={() => handleMark(lead)}
    >
      Mark as Spam
    </button>
  ) : (
    <button
      color="success"
      size="sm"
      className="markButton"
      onClick={() => handleMark(lead)}
    >
      Mark as HAM
    </button>
  )}
</td>
                </tr>
              );
            })
          )}
        </tbody>
         
        {showModal && (
          <ViewForm Modalclose={closeModal} modalData={modalData} />
        )}
        {pdfModal && (
          <PdfModal closeModal={modalClose} modalData={modalData} />
        )}
        {confirmBox && (
          <ConfirmationBox Modalclose={closeDelModal} handleSubmit = {handleMarkAsHam}  />
        )}
      </>
    );
  }
}

export const LeadLength = () => {
  const { data } = useContext(ApiContext);
  return data.leads.length;
};

export default LeadsApi;
